import { createFileRoute, redirect } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute("/app/admin/fsm")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  beforeLoad: () => {
    throw redirect({ to: "/app/admin/fsm-workflows" });
  },
});
